import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { BRANDS } from "../../configs";

const PopoverInputAndIcon = ({
	brand,
	styles,
	value,
	icon,
	tabIndex,
	readOnly,
	showPopover,
	isSOVMobile,
	showToggleIcon,
	onChange,
	handleOnBlur,
	handleOnFocus,
	handleTogglePopover,
	handleClick,
	handleKeyDown
}) => (
	<>
		<input
			className={cx(styles.input, {
				[styles.inputWithIcon]: brand === BRANDS.SWG && icon
			})}
			value={value}
			tabIndex={tabIndex}
			type="text"
			readOnly={readOnly}
			onChange={e => onChange(e.target.value)}
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			onFocus={handleOnFocus}
			onBlur={handleOnBlur}
		/>
		{icon && (showToggleIcon || isSOVMobile) && (
			<button
				type="button"
				className={cx(styles.icon, {
					[styles.iconFlip]: showPopover
				})}
				onClick={handleTogglePopover}>
				{icon}
			</button>
		)}
	</>
);

PopoverInputAndIcon.propTypes = {
	brand: PropTypes.string,
	styles: PropTypes.shape({
		icon: PropTypes.string,
		input: PropTypes.string,
		iconFlip: PropTypes.string,
		inputWithIcon: PropTypes.string
	}),
	value: PropTypes.any.isRequired,
	icon: PropTypes.node,
	tabIndex: PropTypes.string,
	showToggleIcon: PropTypes.bool,
	isSOVMobile: PropTypes.bool,
	readOnly: PropTypes.bool,
	showPopover: PropTypes.bool,
	handleOnBlur: PropTypes.func,
	handleOnFocus: PropTypes.func,
	onChange: PropTypes.func.isRequired,
	handleTogglePopover: PropTypes.func,
	handleClick: PropTypes.func,
	handleKeyDown: PropTypes.func
};

PopoverInputAndIcon.defaultProps = {
	brand: BRANDS.SWG,
	styles: undefined,
	icon: undefined,
	readOnly: true,
	showPopover: false,
	tabIndex: undefined,
	showToggleIcon: false,
	isSOVMobile: false,
	handleOnBlur: () => {},
	handleOnFocus: () => {},
	handleClick: () => {},
	handleKeyDown: () => {},
	handleTogglePopover: () => {}
};

export { PopoverInputAndIcon };
export default PopoverInputAndIcon;
